/**
 * User pursuits API client wrapping the backend /users/:userId/pursuits/*
 * endpoints. Lets a user add or remove a bounty from their pursuits and
 * fetch their pursued bounties as a paginated list.
 * Consumed by the BountyViewSubmit page.
 */
import { api } from "@/lib/axios";
import { Bounty } from "@/types/bounty";
import { fetchPaginatedItems } from "./paginated";

export interface PrivatePursuitQueryParams {
    page?: number;
    perPage?: number;
}

export const UserPursuitAPI = {
    addPursuit: async (userId: number, bountyId: number) => {
        const { data } = await api.post(`/users/${userId}/pursuits/${bountyId}/add`);
        return data;
    },
    removePursuit: async (userId: number, bountyId: number) => {
        const { data } = await api.post(`/users/${userId}/pursuits/${bountyId}/remove`);
        return data;
    },
    fetchPursuits: async (userId: number, params: PrivatePursuitQueryParams = {}) => {
        return fetchPaginatedItems<Bounty>(`/users/${userId}/pursuits`, params);
    },
};
